import type { ConstValues } from '@openx/types/helpers.ts';

export const idOptions = {
  CUSTOM: 'CUSTOM',
  GENERATED: 'GENERATED',
  EXTERNAL: 'EXTERNAL',
};

export type IdOptions = ConstValues<typeof idOptions>;

export const generatedIdTypes = {
  Default: 'Default',
  OX_MPO: 'OX-MPO-',
  OX_TEO: 'OX-TEO-',
  OX_XPA: 'OX-XPA-',
  OX_XPT: 'OX-XPT-',
};

export type GeneratedIdTypes = ConstValues<typeof generatedIdTypes>;

export const generatedDirectDealsIdTypes = {
  OX_DDM: 'OX-DDM-',
};

export type GeneratedDirectDealsIdTypes = ConstValues<typeof generatedDirectDealsIdTypes>;
